/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

/**
 * sessionStorage-backed identity (name/email) used to attribute notes to
 * whoever is using this capture link in this browser tab. sessionStorage
 * (rather than localStorage/cookies) means a new tab naturally re-prompts.
 */

const STORAGE_KEY_PREFIX = 'capture_note_identity_';

/**
 * Get the stored note identity for a capture assignment
 * @param {string} token - Assignment token
 * @returns {{name: string, email: string}|null}
 */
export const getNoteIdentity = (token) => {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${token}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * Store the note identity for a capture assignment
 * @param {string} token - Assignment token
 * @param {{name: string, email: string}} identity
 */
export const setNoteIdentity = (token, identity) => {
  sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${token}`, JSON.stringify(identity));
};
